import { useSubheader } from "../../../../_metronic/layout";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { receiptReducerActions, receiptSagaActions } from "..";

import { OTPModal } from "./OTPModal";
import { ReceiptRetrieved } from "../components/ReceiptRetrieved";
import { ReceiptNotFound } from "../components/ReceiptNotFound";

import { Button, Form, Col, Card, Spinner } from "react-bootstrap";
import { Search, Receipt, InfoCircle } from "react-bootstrap-icons";
import { Formik } from "formik";
import * as Yup from "yup";

import styles from "../css/receipt-retrieval.module.css";

//import { useHistory } from "react-router-dom";

//search form schema definition
const receiptSearchInputSchema = Yup.object().shape({
  receipt_number: Yup.string()
    .matches(/^[Ee]{1}[Rr]{1}[Gg]{1}[A-Za-z0-9]{10}$/, "*Invalid Receipt No. format")
    .min(13, "*Receipt No. must be 13 characters long")
    .max(13, "*Receipt No. must be 13 characters long")
});


export const ReceiptRetrieval = (props) => {
  
  const subheader = useSubheader();
  subheader.setTitle("Receipt Retrieval");

  const initInputValue = {
    receipt_number:""
  };

  const dispatch = useDispatch();

  const { receipt } = useSelector(state => state);
  const { foundReceipt, searchingRcpt, otpValid, jasperRptStr, validatingOTP, otpResult, rcptObj } = receipt;

  const [ rcptSearchMade, setRcptSearchMade ] = useState(false);
  const [ receiptNumber, setReceiptNumber ] = useState("");

  const [ otpModalShow, setOtpModalShow ] = useState(false);
  const [ otpResend, setOtpResend ] = useState(false);

  const [ displayRcpt, setdisplayRcpt ] = useState(false);

  const [ rcptNotFound, setRcptNotFound ] = useState(false);

  useEffect(() => {
    dispatch(receiptReducerActions.reset());
  }, [dispatch]);

  useEffect(() => {
    if (otpValid){
      setOtpModalShow(false);
      setdisplayRcpt(true);
    } else {
      setdisplayRcpt(false);
    }
  }, [otpValid]);

  useEffect(() => {
    if(!foundReceipt && rcptSearchMade){
      setRcptSearchMade(false);
      setRcptNotFound(true);
      return
    } else if(foundReceipt && Object.keys(foundReceipt).length > 0 && rcptSearchMade){
      let query = {
        str: receiptNumber
      };
      dispatch(receiptSagaActions.getOtpCode(query));
      setOtpModalShow(true);
      setRcptSearchMade(false);
    }
  }, [foundReceipt, rcptSearchMade, receiptNumber, dispatch]);


  const validateOTP = (otp) => {
    let query = {
      pin: otp,
      receipt_number: receiptNumber
    };

    dispatch(receiptSagaActions.validateOTP(query));
  };


  const handleOTPResend = () => {
    let query = {
      str: receiptNumber
    };
    dispatch(receiptSagaActions.getOtpCode(query));
    setOtpResend(false);
    setTimeout(() => {
      setOtpResend(true);
    }, 30000);
  };

  const handleOtpModalHide = () => {
    setOtpResend(false);
    setOtpModalShow(false);
  };

  const handleSubmit = (rcpt) => {
    setRcptNotFound(false);
    setdisplayRcpt(false);
    dispatch(receiptReducerActions.reset());
    
    setReceiptNumber(rcpt);
    // let query = {
    //   str: rcpt
    // };

    // dispatch(receiptSagaActions.getOtpCode(query));
    dispatch(receiptSagaActions.findReceipt(rcpt));
    setOtpResend(true);
    setRcptSearchMade(true);

  };

  const closeNotFoundRcpt = () => {
    setRcptNotFound(false);
  };


  return (
    <>
      <OTPModal
        show={otpModalShow}
        onCancel={handleOtpModalHide}
        onSubmit={validateOTP}
        resend={otpResend}
        handleResendOTP={handleOTPResend}
        verifyingOTP={validatingOTP}
        otpVerified={otpValid}
        verificationResult={otpResult}
        verfiedRcptInfo={rcptObj}
      />

      <ReceiptNotFound 
        show={rcptNotFound}
        onClose={closeNotFoundRcpt}
        receiptNumber={receiptNumber}
      />

      <Card>
        <Card.Header>
          <h4> <Receipt color="black" size={30} /> {" "} Find My Receipt </h4>
        </Card.Header>
        <Card.Body>

          <Formik
            initialValues={initInputValue}
            validationSchema={receiptSearchInputSchema}
            onSubmit={(values) => {
              handleSubmit(values.receipt_number);
            }}
          >
            {({ values, errors, touched, handleBlur, handleChange, handleSubmit }) => (
              <Form>
                <Form.Row>
                  <Col lg={4} md={12} sm={12}>
                    <Form.Group controlId="search" className="required">
                      <Form.Control
                        className={styles.hasSearch}
                        size="lg"
                        name="receipt_number"
                        value={values.receipt_number}
                        placeholder="Enter your receipt number"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.receipt_number && errors.receipt_number}
                      />
                      <Form.Control.Feedback type="invalid">
                        <div className="text-danger">{errors.receipt_number}</div>
                      </Form.Control.Feedback>
                    </Form.Group>

                    {/* { rcptNotFound &&
                      <div className="m-3">
                        <p className="text-danger" style={{ fontSize: "14px" }}>
                          <ExclamationCircle color="red" size={20} /> Receipt No. entered is invalid or not found.
                        </p>
                      </div>
                    } */}

                  </Col>
                  <Col lg={4} md={12} sm={12}>
                    <Button
                      type="submit"
                      size="lg"
                      onClick={handleSubmit}
                      variant="primary"
                    >
                      { searchingRcpt ? <Spinner animation="border" role="status" /> : <Search color="white" size={26} /> }
                      <span style={{ marginLeft: "20px" }}>Retrieve Receipt</span>
                    </Button>
                    
                  </Col>
                </Form.Row>
              </Form>
            )}
          </Formik>
          
          <p className="text-muted pt-5 h6"> 
            <InfoCircle size={20} /> Receipt number in the format: 'ERGxxxxxxxxxx'; where x are letters or numbers. 
          </p>
          
        </Card.Body>
      </Card>

      { displayRcpt ? <ReceiptRetrieved item={foundReceipt} reportStr={jasperRptStr} /> : null }
    </>
  );
};
